/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react'
import globals from '../../constants/global.constant'
import styles from './Layout.module.scss'

import {
  TextField,
  Button,
  CircularProgress,
  Autocomplete,
  Checkbox,
  Modal,
} from '@mui/material'
import moment from 'moment-timezone'
import { ModalMessage } from '../ModalMessage/ModalMessage'

export const Profile = ({
  userInfo,
  handleChange,
  handleSelectCalendar,
  handleSelectNotification,
  handleSelectTimeZone,
  handleSave,
  handleDisconnect,
  errorUserInfo,
  isLoadingUpdateUser,
  muaMobile,
  handleUploadImage,
  currentEmail,
  setUserInfo,
  hasChanges,
  profileImage,
}) => {
  const [isEditingEmail, setIsEditingEmail] = useState(false)
  const [allowEditEmail, setAllowEditEmail] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [modalInfo, setModalInfo] = useState({
    title: '',
    message: '',
    button: '',
  })
  const { LastName, FirstName, Email, Calendar, TimeZone, IsActiveNotification } =
    userInfo

  const calendarType = {
    Outlook: '2',
    Google: '1',
  }

  const handleCheck = (event) => {
    const { checked } = event.target
    setAllowEditEmail(checked)
    if (checked) {
      setShowModal(true)
      setModalInfo({
        title: 'Changing your email will require you to sign again.',
        message: 'Do you want to continue editing?',
        cancelButton: 'Cancel',
        button: 'Continue',
      })
    } else {
      setUserInfo({
        ...userInfo,
        Email: currentEmail,
      })
      setAllowEditEmail(false)
      setIsEditingEmail(false)
    }
  }

  const handleClose = () => {
    setAllowEditEmail(false)
    setShowModal(false)
    setModalInfo({
      title: '',
      message: '',
      button: '',
    })
  }

  const handleContinue = () => {
    setIsEditingEmail(true)
    setShowModal(false)
  }

  return (
    <div className={styles.wrapperProfileEdition}>
      <Modal open={showModal} onClose={handleClose}>
        <ModalMessage modalInfo={modalInfo} handleClose={handleContinue} handleCancel={handleClose}/>
      </Modal>
      <div className={styles.sectionTitle}>{`My Profile`}</div>
      <div className={styles.textFields}>
          <>
            <Button 
              className={styles.wrapperNoImage}
              onClick={() => document.getElementById('profile-image-input').click()}
            >
              {profileImage === null ? (
                <img 
                  src={`${globals.imageBasePath}profile-image.png`}
                  alt="camera" 
                />
              ) : (
                <img 
                  src={typeof profileImage === 'string' ? profileImage : URL.createObjectURL(profileImage)}
                  alt="profile"
                />
              )}
              <input
                id="profile-image-input"
                type="file"
                accept="image/*"
                hidden
                onChange={handleUploadImage}
              />
            </Button>
          </>
        <div className={styles.emailWrapper}>
          Email
          <Checkbox 
            checked={allowEditEmail}
            onChange={handleCheck}
            sx={{
              color: '#1a3127',
              '&.Mui-checked': {
                color: '#1a3127',
              },
              '& .MuiSvgIcon-root': {
                fontSize: 26,
              },
            }}
          />
        </div>
        <TextField
          autoComplete="off"
          id="Email"
          onChange={handleChange}
          value={Email}
          error={errorUserInfo.Email.error}
          disabled={!isEditingEmail}
          sx={{
            marginBottom: '15px',
            width: muaMobile ? '300px' : '200px',
            '& .MuiOutlinedInput-input': {
              paddingLeft: '6px',
            },
            '& .MuiInputBase-input.Mui-disabled': {
              WebkitTextFillColor: '#9e9e9e',
              color: '#9e9e9e',
            },
          }}
        />
        <div className={styles.fieldsLabel}>{`First Name`}</div>
        <TextField
          autoComplete="off"
          id="FirstName"
          onChange={handleChange}
          value={FirstName}
          error={errorUserInfo.FirstName.error}
          sx={{
            marginBottom: '15px',
            width: muaMobile ? '300px' : '200px',
            '& .MuiOutlinedInput-input': {
              paddingLeft: '6px',
            },
          }}
        />
        <div className={styles.fieldsLabel}>{`Last Name`}</div>
        <TextField
          autoComplete="off"
          id="LastName"
          onChange={handleChange}
          value={LastName}
          error={errorUserInfo.LastName.error}
          sx={{
            marginBottom: '15px',
            width: muaMobile ? '300px' : '200px',

            '& .MuiOutlinedInput-input': {
              paddingLeft: '6px',
            },
          }}
        />
        <div className={styles.fieldsLabel}>{`Location (Timezone)`}</div>
        <Autocomplete
          id="Timezones"
          value={
            TimeZone?.Name ? { id: TimeZone.Name, label: TimeZone.Name } : null
          }
          disablePortal
          disableClearable
          noOptionsText="No options"
          componentsProps={{
            paper: {
              sx: {
                background: '#14271F',
              },
            },
          }}
          sx={{
            width: muaMobile ? '300px' : '200px',

            '& + .MuiAutocomplete-popper .MuiAutocomplete-option': {
              color: '#F7F7F7 !important',
              background: '#14271F',
            },
          }}
          onChange={(event, value) => handleSelectTimeZone(value)}
          getOptionLabel={(option) => `${option.label}`}
          options={moment.tz.names().map((ele) => ({ id: ele, label: ele }))}
          renderInput={(params) => (
            <TextField
              {...params}
              sx={{
                marginBottom: '15px',
                width: muaMobile ? '300px' : '200px',
              }}
              placeholder={'Select time zone'}
              InputProps={{
                ...params.InputProps,
              }}
            />
          )}
        />

        <div className={styles.fieldsLabel}>{`Email Notifications`}</div>
        <Autocomplete
          id="Notifications"
          value={{
            id: IsActiveNotification,
            label: IsActiveNotification ? 'ON' : 'OFF',
          }}
          disablePortal
          disableClearable
          noOptionsText="No options"
          componentsProps={{
            paper: {
              sx: {
                background: '#14271F',
              },
            },
          }}
          sx={{
            width: muaMobile ? '300px' : '200px',

            '& + .MuiAutocomplete-popper .MuiAutocomplete-option': {
              color: '#F7F7F7 !important',
              background: '#14271F',
            },
          }}
          onChange={(event, value) => handleSelectNotification(value.id)}
          getOptionLabel={(option) => `${option.label}`}
          options={[
            { Name: 'ON', Value: true },
            { Name: 'OFF', Value: false },
          ].map((ele) => ({ id: ele.Value, label: ele.Name }))}
          renderInput={(params) => (
            <TextField
              {...params}
              sx={{
                marginBottom: '15px',
                width: muaMobile ? '300px' : '200px',
              }}
              InputProps={{
                ...params.InputProps,
              }}
            />
          )}
        />
      </div>
      {isLoadingUpdateUser ? (
        <div className={styles.saveButtonWrapper}>
          <CircularProgress
            size="20px"
            color="aqua"
            sx={{ marginTop: '14px' }}
          />
        </div>
      ) : (
        <div className={styles.saveButtonWrapper}>
          <Button onClick={handleSave} className={styles.saveButton} disabled={!hasChanges()}>
            <p>Save changes</p>
          </Button>
        </div>
      )}
      <div className={styles.calendarIntegrationButtons}>
        <div className={styles.sectionTitle}>{`Integrations`}</div>
        <div
          className={styles.sectionHelper}
        >{`Connect the Readiness App with one these available integrations.`}</div>
        <div className={styles.googleButton}>
          <button
            onClick={() => handleSelectCalendar('1')}
            style={
              calendarType[Calendar] === '1' || calendarType[Calendar] === '2'
                ? {
                    border: 'none',
                    background: 'transparent',
                    textTransform: 'none',
                    pointerEvents: 'none',
                    cursor: 'not-allowed',
                  }
                : {
                    border: 'none',
                    background: 'transparent',
                    textTransform: 'none',
                    cursor: 'pointer',
                  }
            }
          >
            <img
              width={'215px'}
              height={'41px'}
              alt="Google sign-in"
              src={
                calendarType[Calendar] === '1' || calendarType[Calendar] === '2'
                  ? `${globals.imageBasePath}btn_google_signin_light_disabled_web.png`
                  : `${globals.logosBasePath}web_light_sq_SI.svg`
              }
            />
          </button>

          <button
            onClick={() => handleSelectCalendar('2')}
            style={
              calendarType[Calendar] === '2' || calendarType[Calendar] === '1'
                ? {
                    border: 'none',
                    background: 'transparent',
                    textTransform: 'none',
                    pointerEvents: 'none',
                    cursor: 'not-allowed',
                  }
                : {
                    border: 'none',
                    background: 'transparent',
                    textTransform: 'none',
                    cursor: 'pointer',
                  }
            }
          >
            <img
              width={'215px'}
              height={'41px'}
              alt="Microsoft sign-in"
              src={
                calendarType[Calendar] === '2' || calendarType[Calendar] === '1'
                  ? `${globals.imageBasePath}ms-symbollockup_signin_light_disabled.png`
                  : `${globals.logosBasePath}ms-symbollockup_signin_light.svg`
              }
            />
          </button>

          <div className={styles.saveButtonWrapper}>
            <Button
              onClick={handleDisconnect}
              className={styles.saveButton}
              disabled={!Calendar}
            >
              <p>Disconnect calendar</p>
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
